// This file was hand edited
export const appVersion= '9.2.12';
